import React from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import { resend } from '../actions/user';
import logo from '../assets/images/image_fitgames_logo.png';
import * as R from 'ramda';
import { Button, message, Form, Statistic } from 'antd';

const FormItem = Form.Item;
const { Countdown } = Statistic;
let deadline;
class Verify extends React.Component {
    constructor(props) {
        super(props);
        let params = queryString.parse(props.location.search);
        const { email } = params;
        deadline = Date.now() + 1000 * 15;
        this.state = {
            initParams: {
                email,
            },
            finished: false,
        }
        this.handleOnLogin = this.handleOnLogin.bind(this);
        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.onFinish = this.onFinish.bind(this);
    }

    componentDidUpdate(prevProps) {

        if (R.isEmpty(prevProps.response.data)) {
            if (this.props.response.data.status === 'success') {
                message.success('已重新發送驗證碼');
                this.setState({
                    finished: false
                })
                deadline = Date.now() + 1000 * 90;
            } else if (this.props.response.data.status === 'fail') {
                const response = this.props.response.data.response;
                const { errors } = response.data;

                const msg = errors === undefined ? '更新失敗' : errors.message;
                message.error(msg);
            }
        }

    }

    handleOnSubmit() {
        this.props.resend(this.state.initParams);
    }

    handleOnLogin() {
        window.location.assign(`/#/login`);
    }

    onFinish() {
        this.setState({
            finished: true
        })
    }

    render() {
        const { email } = this.state.initParams;
        const { finished } = this.state;
        const { isSubmitting } = this.props;
        return (
            <div className="flex-center-center" >
                <div style={{ textAlign: 'center' }}>
                    <img src={logo} alt="fitCloud" style={{ width: '40%' }} />
                    <p className="forgot-title">驗證信箱</p>
                    <p className="verify-body">
                        已寄送驗證信至以下信箱
                        <br></br>
                        請先收信完成驗證，再重新登入
                    </p>
                    <div>
                        <br></br>
                        <p>{email}</p>
                    </div>
                    <Form onSubmit={this.handleOnLogin}>
                        <FormItem>
                            <Button
                                loading={isSubmitting}
                                type="primary"
                                htmlType="submit"
                                style={{
                                    width: '100%',
                                    height: '42px',
                                    opacity: '1',
                                    borderRadius: '25px',
                                    background: 'linear-gradient(to bottom, #f16071, #fdd667) 196%',
                                    border: '0px'
                                }}>重新登入</Button>
                        </FormItem>
                    </Form>

                    {!finished ?
                        <div>
                            <Countdown title='重發驗證信' value={deadline} onFinish={this.onFinish} format="mm:ss" />
                        </div> :
                        <div>
                            <button className="link-btn" onClick={this.handleOnSubmit} >重發驗證信</button>
                        </div>

                    }



                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    response: state.user.submitResponse,
    isSubmitting: state.user.submitResponse.isSubmitting,
    isLogged: state.user.isLogged,
    me: state.user.me,
});

const mapDispatchToProps = {
    resend,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Verify);
